import ArrowRight16 from '@carbon/icons-react/es/arrow--right/16';
import { Row, Col, Divider } from 'antd';
import React, { FC, ReactNode } from 'react';
import { Helmet } from 'react-helmet';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';
import { MenuList } from 'components/atoms/menu';
import { Page } from 'components/molecules/page';
import { Label01 } from 'components/styles';
import { Footer, PaddingX } from 'components/templates/krypton/styled';

interface MenuItemProps {
  route: string;
  menuName: ReactNode;
  menuIcon?: ReactNode;
}

interface LeftMenuItemsProps {
  subHead?: ReactNode;
  value: MenuItemProps[];
}
interface Props {
  documentTitle: ReactNode;
  title: ReactNode;
  leftMenuItems: LeftMenuItemsProps[];
  header?: ReactNode;
  footer?: ReactNode;
}

const Heading = styled.div`
  ${PaddingX};
`;

const LeftMenuBodyWrapper = styled.div`
  overflow: auto;
  ${PaddingX};
  padding-bottom: var(--spacing-09);
  flex-grow: 1;
`;

const LeftMenu = styled(Page.LeftMenu)`
  padding-left: 0;
  padding-right: 0;
  padding-bottom: 0;
`;

const MenuSpan = styled.span`
  display: flex;
  align-items: center;
  gap: var(--spacing-03);
`;

const MenuItem = styled.div`
  display: flex;
  align-items: center;
  > :first-child {
    flex-grow: 1;
  }
  svg {
    color: var(--gray-70);
  }
`;

const Header = styled.p`
  ${Label01};
  padding-left: var(--spacing-05);
  color: var(--gray-50);
  margin-bottom: var(--spacing-03);
`;

export const Krypton: FC<Props> = ({
  documentTitle,
  title,
  leftMenuItems,
  header,
  footer,
  children,
}) => {
  return (
    <>
      <Helmet>{documentTitle}</Helmet>
      <Page $gray>
        <Row>
          <LeftMenu>
            <Heading>
              <div>{header}</div>
              <h5>{title}</h5>
            </Heading>
            <LeftMenuBodyWrapper>
              {leftMenuItems.map((menuItem, index) => {
                return (
                  <MenuList>
                    {menuItem.subHead ? (
                      <li>
                        <Header>{menuItem.subHead}</Header>
                      </li>
                    ) : null}
                    <li>
                      {menuItem.value.map((item) => {
                        return (
                          <>
                            <NavLink to={item.route}>
                              <MenuItem>
                                <MenuSpan>
                                  {item.menuIcon}
                                  {item.menuName}
                                </MenuSpan>
                                <ArrowRight16 />
                              </MenuItem>
                            </NavLink>
                          </>
                        );
                      })}
                    </li>
                    {index !== leftMenuItems.length - 1 && <Divider />}
                  </MenuList>
                );
              })}
            </LeftMenuBodyWrapper>
            {footer ? <Footer>{footer}</Footer> : null}
          </LeftMenu>
          <Col xxl={20} xl={19} lg={19}>
            <Page.Content>{children}</Page.Content>
          </Col>
        </Row>
      </Page>
    </>
  );
};
